import { AxiosInstance } from 'axios';

export default class PermissionsAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async fetchCurrentUserPermissions() {
    return this.client.get('/v2/user/permissions/');
  }

  async fetchUserPermissions({ userId }: { userId: string }) {
    return this.client.get(`/v2/user/${userId}/permissions/`);
  }

  async fetchAllPermissions() {
    return this.client.get('/v2/access-control/permissions/');
  }

  async fetchRolePermissions({ roleId }: { roleId: string }) {
    return this.client.get(`/v2/access-control/role/${roleId}/permissions/`);
  }

  async addRolePermissions({
    roleId,
    data,
  }: {
    roleId: string;
    data: { perm_ids: string[] };
  }) {
    return this.client.post(
      `/v2/access-control/role/${roleId}/permissions/`,
      data,
    );
  }

  async removeRolePermissions({
    roleId,
    data,
  }: {
    roleId: string;
    data: { perm_ids: string[] };
  }) {
    return this.client.delete(
      `/v2/access-control/role/${roleId}/permissions/`,
      {
        data,
      },
    );
  }

  // Sponsor-dashboard access grants for a user
  async getUserSponsorPermissions(userid?: string) {
    return this.client.get('/v2/pmc-permissions/user-sponsor-permissions/', {
      params: userid ? { userid } : undefined,
    });
  }

  async grantUserSponsorPermission(data: {
    userid: string;
    sponsor_id: string;
  }) {
    return this.client.post(
      '/v2/pmc-permissions/user-sponsor-permissions/',
      data,
    );
  }

  async replaceUserSponsorPermissions(data: {
    userid: string;
    sponsor_ids: string[];
  }) {
    return this.client.put(
      '/v2/pmc-permissions/user-sponsor-permissions/',
      data,
    );
  }

  // Toggle whether new entities created under the sponsor are auto-granted to
  // this user. Returns the updated grant (including the new flag value).
  async updateUserSponsorPermission(data: {
    permission_id: string;
    auto_grant_new_companies: boolean;
  }) {
    const { permission_id, auto_grant_new_companies } = data;
    return this.client.patch(
      `/v2/pmc-permissions/user-sponsor-permissions/${permission_id}/`,
      { auto_grant_new_companies },
    );
  }

  async revokeUserSponsorPermission(permissionId: string) {
    return this.client.delete(
      `/v2/pmc-permissions/user-sponsor-permissions/${permissionId}/`,
    );
  }
}
